import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import type { User } from '@shared/models';
import { AuthService, GotoService, UserService } from '@shared/services';
import { BehaviorSubject } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-impersonation-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <ng-container *ngIf="user.impersonate">
      <div class="impersonation-warn full-access" [class.dismissed]="isDismissed$ | async">
        <div class="blink impersonation-text">
          <span
            >WARNING: You are currently impersonating a customer ({{ user.email }} - {{ user.fullName }}), please
            remember to
          </span>
          <a class="signout" (click)="impersonateSignout()"> sign out </a>
        </div>
        <span class="icon ri-cancel dismiss" (click)="dismissBanner()"></span>
      </div>
    </ng-container>
  `,
  styleUrls: ['./impersonation-banner.component.scss'],
})
export class ImpersonationBannerComponent {
  user: User;
  isDismissed$ = new BehaviorSubject<boolean>(false);

  constructor(private userService: UserService, private authService: AuthService, private goto: GotoService) {
    this.user = this.userService.user;
  }

  impersonateSignout() {
    this.authService.logout();
    this.goto.logout();
  }

  dismissBanner() {
    this.isDismissed$.next(true);
  }
}
